import ApiError from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiError";
import NotificationService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/NotificationService";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onSuccess: (_data, query) => {
      if (query.meta?.successMessage) {
        NotificationService.info(query.meta.successMessage as string);
      }
    },
    onError: (error, query) => {
      const errorMessage = (error as ApiError<any>)?.message || (query.meta?.errorMessage as string) || "Error fetching data";
      NotificationService.error(errorMessage);
    },
  }),
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      // Avoid invalidating all queries when mutationKey is undefined.
      if (mutation.options.mutationKey) {
        queryClient.invalidateQueries({
          queryKey: mutation.options.mutationKey,
        });
      }

      if (mutation.meta?.successMessage) {
        NotificationService.info(mutation.meta.successMessage as string);
      }
    },
    onError: (error, _variables, _context, mutation) => {
      const errorMessage = (error as ApiError<any>)?.message || (mutation.meta?.errorMessage as string) || "An unexpected error occurred";
      NotificationService.error(errorMessage);
    },
  }),
});
